import { useState } from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import AttendanceController from '../../controllers/AttendanceController';
import MemberController from '../../controllers/MemberController';
import { MemberViewModel } from '../../models/member/MemberViewModel';
import EventAttendanceViewModel from '../../models/attendance/GetEventAttendance/EventAttendanceViewModel';
import $ from "jquery";
import "datatables.net"
import "datatables.net-dt"
import 'datatables.net-dt/css/jquery.dataTables.css'
import { useEffect } from 'react';

interface IProps{
    updateAttendees: boolean;
    updateAttendeeState: (state: boolean) => void;
    setCurrentMember: (member: MemberViewModel | null) => void;
}

export default function AttendeeList(props: IProps) {
    const [eventAttendees, setEventAttendees] = useState<EventAttendanceViewModel | null>(null)
    const getAttendees = async () => {
        var controller = new AttendanceController();
        var result = await controller.GetEventAttendance("");
        setEventAttendees(null);
        setEventAttendees(result);
    }

    if(props.updateAttendees){
        getAttendees();
        props.updateAttendeeState(false);        
    }

    const findMember = async (id: string) => {
        var controller = new MemberController();
        var member = await controller.GetMemberById({Id: id});
        props.setCurrentMember(member);
    }
    
    useEffect(() => {
        $('#attendeeTable').DataTable();
    })
    

    return (
        <div className="col-12 mx-auto text-center">
            <h3 className="text-center">Attendees ({eventAttendees?.Attendees?.length})</h3>
            {eventAttendees?.MembershipTypes &&
                eventAttendees?.MembershipTypes.map((membershipType, index) => {
                    return <div key={membershipType.Name}> <b>{membershipType.Name}:</b> {membershipType.Count} </div>
                })
            }
            {eventAttendees?.Attendees &&
                    <div className="table-dark table-wrapper-scroll-y full-size-scrollbar">
                    <table id="attendeeTable" className="table table-dark">
                        <thead>
                            <tr>
                                <th scope="col">Firstname</th>
                                <th scope="col">Surname</th>
                                <th scope="col">Key Number</th>
                            </tr>
                        </thead>
                        <tbody>
                            {eventAttendees?.Attendees.map((attendee, index) => {
                                return <tr  onClick={() => findMember(attendee.MemberId)} key={attendee.MemberId}>
                                    <td>{attendee.Firstname}</td>
                                    <td>{attendee.Surname}</td>
                                    <td>{attendee.KeyNumber.toString()}</td>
                                </tr>
                            })}
                        </tbody>
                    </table>
                </div>
            }
        </div >
    );
}